import React from 'react';
import Link from 'next/link';
import MetaHead from '@/Components/MetaHead';

export default function AppPolicies() {
  return (
    <main className="mx-12 md:mx-56 py-12">
      <MetaHead title="Shipping & Exchange | Fyllo" />
      <h1 className="text-center mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-4xl ">
        Shipping &amp; Exchange
      </h1>

      <h2 className="text-3xl py-4 font-semibold">Shipping Information</h2>

      <p>
        At Fyllo, we believe in providing a seamless shopping experience, including hassle-free shipping. Here&apos;s everything you need to know about our shipping policies:
      </p>

      <h2 className="text-2xl py-4 font-semibold">Shipping Methods</h2>

      <p>
        We offer a variety of shipping options to cater to your needs. Delivery times may vary depending on your location and the selected shipping method.
      </p>

      <h2 className="text-2xl py-4 font-semibold">Processing Time</h2>

      <p>
        Orders typically take 1-2 business days to process before they are shipped out. During peak seasons or sales, processing times may be slightly longer. Rest assured, we aim to dispatch your order as swiftly as possible.
      </p>

      <h2 className="text-2xl py-4 font-semibold">Shipping Costs</h2>
      <p>
        Shipping costs are calculated based on the selected shipping method and your delivery address. You can view the shipping charges during the checkout process before making your payment.
      </p>

      <h2 className="text-2xl py-4 font-semibold">Shipping Restrictions</h2>

      <p>
        Please note that we currently only ship within India. Unfortunately, we are unable to deliver to P.O. boxes at this time.
      </p>

      <h2 className="text-2xl py-4 font-semibold">International Shipping</h2>
      <p>
        For international orders, customs duties and taxes may apply upon arrival in your country. These charges are the responsibility of the recipient and are not included in the product price or shipping cost. Please check with your local customs office for more information on potential fees.
      </p>

      <h2 className="text-3xl py-4 font-semibold">Order Changes and Cancellations</h2>

      <p>
        If you need to modify or cancel your order, please contact our customer support team as soon as possible. Once an order has been processed and shipped, we may not be able to make changes.
      </p>

      <h2 className="text-3xl py-4 font-semibold">Missing or Damaged Items</h2>

      <p>
        In the rare event that your order arrives with missing or damaged items, please reach out to our support team within 48 hours of receiving your package. We’ll work swiftly to resolve the issue.
      </p>


      <h2 className="text-3xl py-4 font-semibold">Exchange Policy Based on Device Condition</h2>
      <p>
        We understand the importance of your device&apos;s condition. Our local team evaluates devices to ensure precise exchange assessments. Here’s an outline of our exchange process:
      </p>

      <h3 className="text-2xl py-2 font-semibold">Initiating an Exchange</h3>
      <ol className="list-decimal ml-6">
        <li>Contact Us: Get in touch with our customer service team at <a href="mailto:contact@fyllo.in">contact@fyllo.in</a> within 30 days of receiving your order to start an exchange.</li>
        <li>Assessment Process: Our local team will guide you through the assessment process. They&apos;ll evaluate the device&apos;s condition based on predetermined criteria.</li>
        <li>Approval and Exchange: Upon approval, we&apos;ll provide instructions for the exchange. Please securely package the device for return.</li>
      </ol>

      <h3 className="text-2xl py-2 font-semibold">Conditions for Exchange</h3>
      <ul className="list-disc ml-6">
        <li>Device Condition: To qualify for an exchange, the device must meet predetermined criteria established by our assessment team. Criteria include functionality, physical condition, and presence of original accessories.</li>
        <li>Original Packaging: Ensure the device is returned in its original packaging.</li>
        <li>Timeframe: Exchanges must be initiated within 30 days of receiving the order.</li>
      </ul>

      <h3 className="text-2xl py-2 font-semibold">Refunds and Processing</h3>
      <p>
        Refunds for returned items will be processed within 5-7 business days after receiving the merchandise. Exchanges will be facilitated based on the local team&apos;s assessment of the device condition.
      </p>

      <h2 className="text-3xl py-4 font-semibold">Contact Us</h2>
      <p>
        For any further inquiries regarding shipping, exchange or to seek assistance with your order, please don’t hesitate to contact us:
      </p>
      <ul>
        <li><a href="mailto:contact@fyllo.in">By email: contact@fyllo.in</a></li>
      </ul>
      <p className='text-lg py-4'>
        Thank you for choosing Fyllo! We strive to make your shopping experience as smooth as possible, and our commitment to efficient shipping is part of that promise.
      </p>
    </main>

  );
}
